export default {
    formId: 'editCompanyForm', //'checkoutForm',
    formField: {
      e_type_document: {
        name: 'e_type_document',
        label: 'Tipo de documento',
        requiredErrorMsg: 'Tipo de documento es requerido.'
      },
      e_number_document: {
        name: 'e_number_document',
        label: 'Numero de documento*',
        requiredErrorMsg: 'Numero de documento es requerido.',
        typeDataMsg: 'El campo es numerico.'
      },
      e_tradename: {
        name: 'e_tradename',
        label: 'Nombre comercial*',
        requiredErrorMsg: 'Nombre comercial es requerido.'
      },
      e_business_name: {
        name: 'e_business_name',
        label: 'Razon social*',
        requiredErrorMsg: 'La razon social es requerida.'
      },
      e_legal_representative: {
        name: 'e_legal_representative',
        label: 'Representante legal*',
        requiredErrorMsg: 'El representante legal es requerido.'
      },
      e_email: {
        name: 'e_email',
        label: 'Email*',
        requiredErrorMsg: 'El email  es requerido.'
      },
      e_manager_in_charge: {
        name: 'e_manager_in_charge',
        label: 'Gerente*',
        requiredErrorMsg: 'El gerente gerente es requerido.',
      },
      e_economic_activity: {
        name: 'e_economic_activity',
        label: 'Actividad Economica*',
        requiredErrorMsg: 'La actividad ecomonica es requerida.',
      },
      e_branch_offices: {
        name: 'e_branch_offices',
        label: 'Tiene sucursales?'
      },
      e_country: {
        name: 'e_country',
        label: 'Pais',
        requiredErrorMsg: 'El pais es requerido.',
      },
      e_departament: {
        name: 'e_departament',
        label: 'Departamento',
        requiredErrorMsg: 'El departamento es requerido.'
      },
      e_municipaly: {
        name: 'e_municipaly',
        label: 'Municipio',
        requiredErrorMsg: 'El municipio es requerido.',
        // invalidErrorMsg: 'Card number is not valid (e.g. 4111111111111)'
      },
      e_address_company: {
        name: 'e_address_company',
        label: 'Direccion*',
        requiredErrorMsg: 'La direccion es requerida.',
        // invalidErrorMsg: 'Expiry date is not valid'
      },
      e_workplace: {
        name: 'e_workplace',
        label: 'Sitio de trabajo',
        requiredErrorMsg: 'El sitio de trabajo es requerido.',
        // invalidErrorMsg: 'CVV is invalid (e.g. 357)'
      },
      e_landline: {
        name: 'e_landline',
        label: 'Telefono fijo'
      },
      e_cell_phone: {
        name: 'e_cell_phone',
        label: 'Celular'
      },

      // forma de pago 
      e_payment_frequency: {
        name: 'e_payment_frequency',
        label: 'Frecuencia de pago',
        requiredErrorMsg: 'Frecuencia de pago es requerida.'
      },
      e_payment_method: {
        name: 'e_payment_method',
        label: 'Metodo de pago',
        requiredErrorMsg: 'Metodo de pago es requerido.'
      },
      e_associated_bank: { 
        name: 'e_associated_bank',
        label: 'Banco asociado',
        requiredErrorMsg: 'Banco asociado es requerido.'
      },
      e_type_account_bank: {
        name: 'e_type_account_bank',
        label: 'Tipo de cuenta',
        requiredErrorMsg: 'Tipo de cuenta es requerida.'
      },
      e_account_number: {
        name: 'e_account_number',
        label: 'Numero de cuenta',
        requiredErrorMsg: 'Numero de cuenta es requerido.'
      },


      // SEGURIDAD SOCIAL 
      e_sgsst: {
        name: 'e_sgsst',
        label: 'Plataforma para SST',
        requiredErrorMsg: 'Plataforma para SST es requerida.'
      },
      e_arl: {
        name: 'e_arl',
        label: 'ARL Vinculada a la empresa',
        requiredErrorMsg: 'ARL Vinculada a la empresa es requerida.'
      },
      e_constitution_date: {
        name: 'e_constitution_date',
        label: 'Fecha de Constitución',
        requiredErrorMsg: 'Fecha de Constitución es requerida.'
      },
      e_ley_1429_2010: {
        name: 'e_ley_1429_2010',
        label: 'Acoge la ley 1429 de 2010'
      },
      e_ley_590_2000: {
        name: 'e_ley_590_2000',
        label: 'Acoge la ley 590 2000'
      },
      e_ley_1607_2012: {
        name: 'e_ley_1607_2012',
        label: 'Acoge la ley 1607 2012'
      },
      e_ley_1607_201a2: {
        name: 'e_ley_1607_2012',
        label: 'ley 1607 2012'
      },

      // ARCHIVOS 
      e_rut: {
        name: 'e_rut',
        label: 'Rut',
        requiredErrorMsg: 'Rut es requerido.'
      },
      e_rut_name_saved_file: {
        name: 'e_rut_name_saved_file',
        label: 'rut_name_saved_file',
        requiredErrorMsg: 'Rut es requerido.'
      },
      e_chamber_of_commerce: {
        name: 'e_chamber_of_commerce',
        label: 'Camara y comercio',
        requiredErrorMsg: 'Camara y comercio es requerido.'
      },
      e_chamber_of_commerce_name_saved_name: {
        name: 'e_chamber_of_commerce_name_saved_name',
        label: 'Camara y comercio',
        requiredErrorMsg: 'Camara y comercio es requerido.'
      },
      e_bank_certificate: {
        name: 'e_bank_certificate',
        label: 'Certificado bancario',
        requiredErrorMsg: 'Certificado bancario es requerido.'
      },
      e_bank_certificate_name_saved_name: {
        name: 'e_bank_certificate_name_saved_name',
        label: 'Certificado bancario',
        requiredErrorMsg: 'Certificado bancario es requerido.'
      },
      // LOGOS NOMBRE COMERCIAL 
      e_logo_bn_company: {
        name: 'e_logo_bn_company',
        label: 'Logo razon social',
        requiredErrorMsg: 'Logo razon social es requerido.'
      },
      e_logo_bn_company_name_saved_file: {
        name: 'e_logo_bn_company_name_saved_file',
        label: 'Logo razon social',
        requiredErrorMsg: 'Logo razon social es requerido.'
      },
      e_logo_bn_post_company: {
        name: 'e_logo_bn_post_company',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      }, 
      e_logo_bn_rz_post_company_name_saved_file: {
        name: 'e_logo_bn_rz_post_company_name_saved_file',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      },
      // LOGOS POST COMERCIAL 
      e_logo_company: {
        name: 'e_logo_company',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      },
      e_logo_company_name_saved_file: {
        name: 'e_logo_company_name_saved_file',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      },
      e_logo_post_company: {
        name: 'e_logo_post_company',
        label: 'Logo post compañia',
        requiredErrorMsg: 'Logo post compañia es requerido.'
      },
      e_logo_post_company_name_saved_file: {
        name: 'e_logo_post_company_name_saved_file',
        label: 'Logo post compañia',
        requiredErrorMsg: 'Logo post compañia es requerido.'
      },
    }
  };
  